import "./ProgressCircle.scss";

const ProgressCircle = ({
    percentage = 0,
    label,
    value,
    size = 120,
    strokeWidth = 12,
    showPercentage = true,
    showValue = true,
    className = "",
    animated = true,
    ...props
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
        <div className={`progress-circle ${className}`} {...props}>
            <div
                className="progress-circle__chart"
                style={{ width: size, height: size }}
            >
                <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        strokeWidth={strokeWidth}
                        fill="none"
                        className="progress-circle__background"
                    />
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        strokeWidth={strokeWidth}
                        fill="none"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        strokeLinecap="round"
                        className={`progress-circle__progress ${
                            animated
                                ? "progress-circle__progress--animated"
                                : ""
                        }`}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    />
                </svg>

                <div className="progress-circle__content">
                    {showPercentage && (
                        <div className="progress-circle__percentage">
                            {percentage}%
                        </div>
                    )}
                    {showValue && value && (
                        <div className="progress-circle__value">{value}</div>
                    )}
                </div>
            </div>

            {label && <div className="progress-circle__label">{label}</div>}
        </div>
    );
};

export default ProgressCircle;
